interface PostBodyNode {
  type: string;
  children?: any[];
  text?: string;
  [key: string]: any;
}

interface PostBody {
  root: {
    type: string;
    children: PostBodyNode[];
  };
}

/**
 * Extract plain text from post body lexical structure
 * Limited to first 150 characters
 */
export const extractTextFromPostBody = (postBody: PostBody, maxLength = 150): string => {
  if (!postBody?.root?.children) return "";

  let text = "";

  const extractText = (nodes: PostBodyNode[]): void => {
    for (const node of nodes) {
      if (text.length >= maxLength) break;

      if (node.text) {
        text += node.text;
      }

      if (node.children && Array.isArray(node.children)) {
        extractText(node.children);
      }
    }
  };

  extractText(postBody.root.children);

  if (text.length > maxLength) {
    text = `${text.substring(0, maxLength).trim()}...`;
  }

  return text;
};

/**
 * Format date to "MMM DD, YYYY" format
 */
export const formatNewsDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};
